/**
 * Created by david on 2017/4/22.
 */

import axios from 'axios';
import store from '../store';
import {ACCOUNT_UPDATE_TOKEN} from '../store/mutation';
import router from '../router';
import handleError from 'helpers/handleError';

const HOST = '';
const PRE = '/api/';

class Api {
    axios = axios;

    constructor() {
    }

    /**
     * 全局URL 替换处理
     * @param  {string} url
     * @returns {string}  处理后的url
     */
    getUrl(url) {
        if (url.indexOf('{') >= 0) {
            url = url.replace('{PRE}', PRE);
        }
        return HOST + url;
    }

    getConfig(_url, _method, _parameter) {
        let config = {
            method: _method ? _method : 'get',
            url: this.getUrl(_url),
            data: _parameter ? _parameter : ''
        };
        if (config.method === 'get' && Object.keys(config.data).length > 0) { //拼接URL
            var quertString = [];
            Object.keys(config.data).forEach(function (key) {
                quertString.push(key + '=' + config.data[key]);
            })
            config.url = config.url + '?' + quertString.join('&');
        }
        return config;
    }

    get(url, param = '') {
        return this.fetch(url, 'get', param);
    }

    post(url, param = '') {
        return this.fetch(url, 'post', param);
    }

    fetch(url, method, param) {
        let Api = this;
        let config = this.getConfig(this.getUrl(url), method, param);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.accountToken;
        return axios(config).then(function (response) {
            return response.data;
        }).catch(function (error) {
            console.log('error=============', error);
            // Token has expired;
            // TODO 捕捉 超时 等网络错误; Token has expired
            if (error.response.status === 401
                || error.response.data.message === 'Token has expired'
            ) {
                return Api.refreshToken().then(function (access_token) {
                    console.log('刷新token 成功, 开始加载数据 :' + access_token);
                    if (access_token) {
                        //debugModel
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
                        return axios(config).then((response) => {
                            return response;
                        });
                    } else {
                        throw error;
                    }
                }).catch(function (error) {
                    router.push({name: 'login'});
                })
            } else {
                // 非token错误 将错误重新抛出;
                // 将网络报错内容 正确抛出;
                return handleError.ajaxError(error)
            }
        })

    }

    fetchData(_url, _method, _parameter) {
        let config = this.getConfig(_url, _method, _parameter);
        axios.defaults.headers.common['Authorization'] = '';
        return axios(config).then(function (response) {
            return response.data;
        }).catch(handleError.ajaxError)
    }

    refreshToken() {
        var url = this.getUrl('/api/account/refreshtoken') + '?token=' + store.getters.accountToken;
        return axios.get(url).then(function (response) {
            if (response.data && response.data.data && response.data.data.access_token) {
                store.commit(ACCOUNT_UPDATE_TOKEN, response.data.data.access_token);
                return response.data.data.access_token;
            }
        });
    }

}
export default Api;



// WEBPACK FOOTER //
// ./src/api/index.js